import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { ApiService } from '../../../../core/services/ApiService';
import { IEmployee } from '../interfaces/IEmployee';
import { EmployeesStore } from '../stores/EmployeesStore';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {

  private readonly _basePath = '/employees';
  private readonly _apiService = inject(ApiService);
  private readonly _employeesStore = inject(EmployeesStore);

  public getMyEmployee(): Observable<IResponse<IEmployee>> {
    return this._apiService.get(`${this._basePath}/my-employee`)
      .pipe(
        tap(res => {
          this._employeesStore.myEmployee.set(res.data);

          const { email, initialLetters, firstName, lastName } = res.data;
          const others = this._employeesStore.lastLoggedEmployees()
            .filter(x => x.email !== email);

          if (!initialLetters) {
            this._employeesStore.lastLoggedEmployees.set(others);
            return;
          }

          this._employeesStore.lastLoggedEmployees.set([
            {
              email,
              initialLetters,
              firstName,
              lastName,
            },
            ...others,
          ]);
        })
      );
  }
}
